import { assign, findIndex, remove, isEmpty } from 'lodash';
import  * as types from '../actions/ActionTypes';
import {IControlError, IControlSchema} from "../components/Controls";
import * as equal from "fast-deep-equal";
import {Dictionary} from "../types/Dictionary";

export interface FormState {
    form: any;
    values: Array<any>,
    section:string,
    listUserForms: Array<any>,
    checkedPanel: Array<string>,
    user: any,
    settings: any,
    countToSend: number,
    errors: Dictionary<IControlError | undefined>,
    visited: Dictionary<boolean>,
    allVisited: boolean,
    readonly?: boolean,
    status?: number,
    formUid?: string,
}

const defaultState : FormState = {
    form: {},
    values:[],
    section:'1',
    listUserForms:[],
    checkedPanel:[],
    user: {},
    countToSend: 0,
    errors: {},
    visited: {},
    allVisited: false,
    settings: {},
};

export interface Action{
    type:string;
    payload: any;
}

function updateControls(controls: any[], updater: (control: any) => void) {
    return controls.map(c => {
        if(c.controls) {
            c = {...c, controls: updateControls(c.controls, updater)};
        }

        return updater(c);
    })
}

function updateStateControls(state: any, updater: (control: any) => void) {
    const newForm = {
        ...state.form,
        sections: state.form.sections.map(s => ({
            ...s,
            controls: updateControls(s.controls, updater)
        }))
    };
    return {...state, form: newForm};
}

export function forms(state : FormState = defaultState, action : Action){

    switch(action.type){
        case types.FETCH_FORM:
            return assign({},state,{ form: action.payload, errors: {}, visited: {}, allVisited: false });
        case types.ADD_VALUE: {
            const stamp = +new Date();
            const valuesLookUp: { [key: string]: any }  = {};
            action.payload.forEach(p => valuesLookUp[p.controlid] = p.value);
            const newForm = {
                ...state.form,
                sections: state.form.sections.map(s => ({
                    ...s,
                    $$timestamp: stamp,
                    controls: updateControls(s.controls, c => ({...c, value: valuesLookUp[c.id]}))
                }))
            };
            return assign({}, state, {values: [...action.payload], form: newForm});
        }
        case types.SET_SECTION:
            return assign({},state,{ section:action.payload.id });
        case types.SET_FORM_UID:
            return assign({}, state, { formUid: action.payload } );
        case types.CLEAR_VALUES:
            return  assign({},state,{ values:[], form:{}, readonly: undefined, errors: {}, visited: {}, allVisited: false  });
        case types.FETCH_VALUES:
            return assign({},state, { listUserForms: action.payload});
        case types.OPEN_FORM: {
            const valuesLookUp: { [key: string]: any }  = {};
            action.payload.values.forEach(p => valuesLookUp[p.controlid] = p.value);
            action.payload.form = {
                ...action.payload.form,
                sections: action.payload.form.sections.map(s => ({
                    ...s,
                    controls: updateControls(s.controls, c => ({...c, value: valuesLookUp[c.id] || c.value}))
                }))
            };

            return assign({}, state, {...action.payload, errors: {}, visited: {}, allVisited: false});
        }
        case types.CHECKED_PANEL:
            return action.payload.checked ?
                assign({},state, { checkedPanel: [...state.checkedPanel, action.payload.panelId] }) :
                assign({},state, { checkedPanel: remove(state.checkedPanel, (id) => id !== action.payload.panelId ) });
        case types.AUTH_USER_SUCcESS:
            return assign({},state, { user: action.payload});
        case types.ATTEMPT_TO_SEND:
            return assign({},state,{ countToSend: action.payload });
        case types.SET_STATUS_DEFAULT:
            return assign({},state,{ status: action.payload });
        case types.CREATE_REQUEST_BEFORE:
            return assign({},state,{ checkedPanel: [] });
        case types.REQUEST_UNCHEK_UPDATE:
            let requests = [...state.listUserForms];
            let idx = findIndex(requests, (obj) => obj.formId === action.payload.formId &&
                                                    obj.valuesId === action.payload.valuesId);
            if(idx > -1){
                requests[idx].updateState = '';
            }
            return  assign({},state, { listUserForms: requests});
        case types.MARK_VISITED: {
            if (!state[action.payload]) {
                return {...state, visited: {...state.visited, ...{[action.payload]: true}}};
            }
            return state;
        }
        case types.SET_ERROR: {
            if(state.errors[action.payload.id] !== action.payload.error) {
                return {...state, errors: {...state.errors, ...{[action.payload.id]: action.payload.error}}};
            }
            return state;
        }
        case types.MARK_ALL_VISITED: {
            return {...state, allVisited: true};
        }
        case types.SET_SETTINGS: {
            return {...state, settings: action.payload};
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/index.ts